/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupplierDeliveryDTOFromJSON, SupplierDeliveryDTOToJSON, } from './SupplierDeliveryDTO';
import { WarehouseShipToAddressDTOFromJSON, WarehouseShipToAddressDTOToJSON, } from './WarehouseShipToAddressDTO';
/**
 * @export
 */
export const OrderWarehouseInfoDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const OrderWarehouseInfoDTODispatchModeEnum = {
    Ship: 'SHIP',
    Hold: 'HOLD',
    NotComing: 'NOT_COMING'
};
/**
 * @export
 */
export const OrderWarehouseInfoDTOTrackingCheckStatusEnum = {
    NoTracking: 'NO_TRACKING',
    Match: 'MATCH',
    Mismatch: 'MISMATCH'
};
/**
 * Check if a given object implements the OrderWarehouseInfoDTO interface.
 */
export function instanceOfOrderWarehouseInfoDTO(value) {
    return true;
}
export function OrderWarehouseInfoDTOFromJSON(json) {
    return OrderWarehouseInfoDTOFromJSONTyped(json, false);
}
export function OrderWarehouseInfoDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'initialWarehouseCostUsd': json['initialWarehouseCostUsd'] == null ? undefined : json['initialWarehouseCostUsd'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingUrl': json['trackingUrl'] == null ? undefined : json['trackingUrl'],
        'sentFromWarehouseDate': json['sentFromWarehouseDate'] == null ? undefined : (new Date(json['sentFromWarehouseDate'])),
        'receivedAt': json['receivedAt'] == null ? undefined : (new Date(json['receivedAt'])),
        'purchaseConfirmedAt': json['purchaseConfirmedAt'] == null ? undefined : (new Date(json['purchaseConfirmedAt'])),
        'shippinglotOrderId': json['shippinglotOrderId'] == null ? undefined : json['shippinglotOrderId'],
        'shippinglotStatus': json['shippinglotStatus'] == null ? undefined : json['shippinglotStatus'],
        'shippinglotShippingCost': json['shippinglotShippingCost'] == null ? undefined : json['shippinglotShippingCost'],
        'shippinglotShippingCurrency': json['shippinglotShippingCurrency'] == null ? undefined : json['shippinglotShippingCurrency'],
        'shippinglotCarrierPrice': json['shippinglotCarrierPrice'] == null ? undefined : json['shippinglotCarrierPrice'],
        'shippinglotDiscountAmount': json['shippinglotDiscountAmount'] == null ? undefined : json['shippinglotDiscountAmount'],
        'shippinglotCustomsFees': json['shippinglotCustomsFees'] == null ? undefined : json['shippinglotCustomsFees'],
        'shippinglotInsuranceFee': json['shippinglotInsuranceFee'] == null ? undefined : json['shippinglotInsuranceFee'],
        'shippinglotServiceFees': json['shippinglotServiceFees'] == null ? undefined : json['shippinglotServiceFees'],
        'shippinglotOtherFees': json['shippinglotOtherFees'] == null ? undefined : json['shippinglotOtherFees'],
        'shippinglotWarehouse': json['shippinglotWarehouse'] == null ? undefined : json['shippinglotWarehouse'],
        'shippinglotOrderType': json['shippinglotOrderType'] == null ? undefined : json['shippinglotOrderType'],
        'shippinglotIsPartial': json['shippinglotIsPartial'] == null ? undefined : json['shippinglotIsPartial'],
        'shippinglotDeliveryPeriod': json['shippinglotDeliveryPeriod'] == null ? undefined : json['shippinglotDeliveryPeriod'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'lastSubmissionAttemptAt': json['lastSubmissionAttemptAt'] == null ? undefined : (new Date(json['lastSubmissionAttemptAt'])),
        'lastSubmissionError': json['lastSubmissionError'] == null ? undefined : json['lastSubmissionError'],
        'manualFulfillment': json['manualFulfillment'] == null ? undefined : json['manualFulfillment'],
        'shipmentHoldAt': json['shipmentHoldAt'] == null ? undefined : (new Date(json['shipmentHoldAt'])),
        'warehouseCancelledAt': json['warehouseCancelledAt'] == null ? undefined : (new Date(json['warehouseCancelledAt'])),
        'dispatchMode': json['dispatchMode'] == null ? undefined : json['dispatchMode'],
        'amazonShipmentConfirmedAt': json['amazonShipmentConfirmedAt'] == null ? undefined : (new Date(json['amazonShipmentConfirmedAt'])),
        'amazonTrackingNumbers': json['amazonTrackingNumbers'] == null ? undefined : json['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': json['shippinglotTrackingNumber'] == null ? undefined : json['shippinglotTrackingNumber'],
        'trackingCheckStatus': json['trackingCheckStatus'] == null ? undefined : json['trackingCheckStatus'],
        'trackingCheckedAt': json['trackingCheckedAt'] == null ? undefined : (new Date(json['trackingCheckedAt'])),
        'trackingCheckError': json['trackingCheckError'] == null ? undefined : json['trackingCheckError'],
        'warehouseShipToAddress': json['warehouseShipToAddress'] == null ? undefined : WarehouseShipToAddressDTOFromJSON(json['warehouseShipToAddress']),
        'supplierDelivery': json['supplierDelivery'] == null ? undefined : SupplierDeliveryDTOFromJSON(json['supplierDelivery']),
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
    };
}
export function OrderWarehouseInfoDTOToJSON(json) {
    return OrderWarehouseInfoDTOToJSONTyped(json, false);
}
export function OrderWarehouseInfoDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehousePackageId': value['warehousePackageId'],
        'packageStatus': value['packageStatus'],
        'initialWarehouseCostUsd': value['initialWarehouseCostUsd'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'trackingNumber': value['trackingNumber'],
        'trackingUrl': value['trackingUrl'],
        'sentFromWarehouseDate': value['sentFromWarehouseDate'] == null ? undefined : ((value['sentFromWarehouseDate']).toISOString()),
        'receivedAt': value['receivedAt'] == null ? undefined : ((value['receivedAt']).toISOString()),
        'purchaseConfirmedAt': value['purchaseConfirmedAt'] == null ? undefined : ((value['purchaseConfirmedAt']).toISOString()),
        'shippinglotOrderId': value['shippinglotOrderId'],
        'shippinglotStatus': value['shippinglotStatus'],
        'shippinglotShippingCost': value['shippinglotShippingCost'],
        'shippinglotShippingCurrency': value['shippinglotShippingCurrency'],
        'shippinglotCarrierPrice': value['shippinglotCarrierPrice'],
        'shippinglotDiscountAmount': value['shippinglotDiscountAmount'],
        'shippinglotCustomsFees': value['shippinglotCustomsFees'],
        'shippinglotInsuranceFee': value['shippinglotInsuranceFee'],
        'shippinglotServiceFees': value['shippinglotServiceFees'],
        'shippinglotOtherFees': value['shippinglotOtherFees'],
        'shippinglotWarehouse': value['shippinglotWarehouse'],
        'shippinglotOrderType': value['shippinglotOrderType'],
        'shippinglotIsPartial': value['shippinglotIsPartial'],
        'shippinglotDeliveryPeriod': value['shippinglotDeliveryPeriod'],
        'carrierName': value['carrierName'],
        'carrierService': value['carrierService'],
        'lastSubmissionAttemptAt': value['lastSubmissionAttemptAt'] == null ? undefined : ((value['lastSubmissionAttemptAt']).toISOString()),
        'lastSubmissionError': value['lastSubmissionError'],
        'manualFulfillment': value['manualFulfillment'],
        'shipmentHoldAt': value['shipmentHoldAt'] == null ? undefined : ((value['shipmentHoldAt']).toISOString()),
        'warehouseCancelledAt': value['warehouseCancelledAt'] == null ? undefined : ((value['warehouseCancelledAt']).toISOString()),
        'dispatchMode': value['dispatchMode'],
        'amazonShipmentConfirmedAt': value['amazonShipmentConfirmedAt'] == null ? undefined : ((value['amazonShipmentConfirmedAt']).toISOString()),
        'amazonTrackingNumbers': value['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': value['shippinglotTrackingNumber'],
        'trackingCheckStatus': value['trackingCheckStatus'],
        'trackingCheckedAt': value['trackingCheckedAt'] == null ? undefined : ((value['trackingCheckedAt']).toISOString()),
        'trackingCheckError': value['trackingCheckError'],
        'warehouseShipToAddress': WarehouseShipToAddressDTOToJSON(value['warehouseShipToAddress']),
        'supplierDelivery': SupplierDeliveryDTOToJSON(value['supplierDelivery']),
        'imageUrls': value['imageUrls'],
    };
}
